const styles = {
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    },
    responsiveVideoWrapper: {
        width: '100%',
        height: '100%'
    },
    coverVideo: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    controls: {
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        zIndex: 1
    },
    controlButton: {
        variant: 'unstyled',
        boxSize: '24px',
        minW: '24px',
        width: '24px',
        height: '24px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        bg: 'transparent',
        _hover: {
            bg: 'transparent'
        },
        _active: {
            bg: 'transparent'
        },
        _focus: {
            boxShadow: 'none'
        }
    },
    caption: {
        mt: 2
    }
}

export default styles
